export const BUILT_IN_SETUP_READINESS_UI_IDS = Object.freeze([
  "builder-connect-card",
  "onboarding",
  "provider-readiness-badge",
  "setup-connections-page",
] as const);
